// @module Tavanoteam.FrequentlyBoughtTogether.FrequentlyBoughtTogether
define("Tavanoteam.FrequentlyBoughtTogether.FrequentlyBoughtTogether.View", [
  "tavanoteam_frequentlyboughttogether_frequentlyboughttogether.tpl",

  "Tavanoteam.FrequentlyBoughtTogether.FrequentlyBoughtTogether.Model",
  "GlobalViews.Confirmation.View",

  "Backbone",
  "Utils",
  "jQuery",
  "underscore",
], function (
  tavanoteam_frequentlyboughttogether_frequentlyboughttogether_tpl,

  FrequentlyBoughtTogetherModel,
  GlobalViewsConfirmationView,

  Backbone,
  Utils,
  jQuery,
  _
) {
  "use strict";

  // @class Tavanoteam.FrequentlyBoughtTogether.FrequentlyBoughtTogether.View @extends Backbone.View
  return Backbone.View.extend({
    template: tavanoteam_frequentlyboughttogether_frequentlyboughttogether_tpl,

    contextDataRequest: ["item"],

    initialize: function (options) {
      Backbone.View.prototype.initialize.apply(this, arguments);

      var self = this;

      //Frequently Bought Together Model
      this.model = new FrequentlyBoughtTogetherModel();

      //Get Container
      this.container = options.container;
      this.layout = this.container.getComponent("Layout");
      this.application = this.layout.application;
      this.environment = this.container.getComponent("Environment");
      this.cart = this.container.getComponent("Cart");
      this.pdp = this.container.getComponent("PDP");
      this.getLayout = this.application.getLayout();

      //Get Minimum Correlation Value From SC Configuration
      this.getMinimumCorrelation =
        SC.CONFIGURATION.TTFrequentlyBoughtTogether.minimumCorrelation;

      //Get Maximum Number of Correlated Items From SC Configuration
      this.getMaximumNumber =
        SC.CONFIGURATION.TTFrequentlyBoughtTogether.maximumCorrelatedItems;

      //Get Strikethrough Properties From SC Configuration
      this.strikeThroughForMatrix = SC.CONFIGURATION.TTFrequentlyBoughtTogether.enableStrikeThroughForMatrix;
      this.strikethroughEnabled = SC.CONFIGURATION.priceLevel.enabled;
      this.strikethroughPriceLevel = SC.CONFIGURATION.priceLevel.default;

      //Get Settings
      this.touchpoint = this.environment.getConfig().currentTouchpoint;
      this.showRating =
        SC.ENVIRONMENT.REVIEWS_CONFIG && SC.ENVIRONMENT.REVIEWS_CONFIG.enabled;

      //Get PDP Info
      this.item = this.pdp.getItemInfo().item;
      this.itemID = this.item.internalid;
      //Get Eligible Items after PDP loads
      this.pdp.on("afterShowContent", function () {
        self.getEligibleItems();
      });
    },

    //  **** Fetch Eligible Correlated Items that meet the Minimum Correlation Value ****

    getEligibleItems: function () {
      var self = this;
      var item = this.item,
        itemId = item.internalid,
        minimumCorrelation = self.getMinimumCorrelation, //Minimum Correlation Value
        maximumNumber = self.getMaximumNumber; //Maximum Number of Correlated Items

      if (!item.custitem_tt_override_fbt || item.custitem_tt_override_item_list_id == "") {
        console.log('FBT - No Override');
        this.model
          .fetch({
            data: { itemId: itemId },
          })
          .done(function (result) {
            //Top Eligible Items with Minimum Correlation Value
            self.eligibleItems = result
              .filter(function (i) {
                return i.correlateditemcorrelation >= minimumCorrelation;
              })
              .slice(0, maximumNumber);

            self.render();
          });
      } else {
        console.log('FBT - Override');
        var searchComponent = this.container.getComponent("Search");
        var paramsOverrideFBTItems = {
          id: this.item.custitem_tt_override_item_list_id,
          fieldset: "search",
        };
        var overrideFBTItemsURL = searchComponent.getUrl(
          paramsOverrideFBTItems
        );
        var overrideFBTItemsPromise = jQuery.ajax(overrideFBTItemsURL);
        overrideFBTItemsPromise.then(function (data, result, jqXhr) {
          self.overrideFBTItems = data.items;
          self.eligibleItems = data.items;
          self.render();
        });
      }
    },

    //  **** Start Get Item Information Function ****

    //Get Corresponding Item Object of Eligible Correlated Items
    getEligibleInfo: function () {
      var self = this;
      var item = this.item,
        correlatedItems = item.correlateditems_detail,
        eligibleItems = this.eligibleItems;

      //Get Eligible Items from Correlated Items Detail
      var eligibleItemsObj = correlatedItems.filter(function (i) {
        return eligibleItems.some(function (j) {
          return i.internalid == j.correlateditemid;
        });
      });

      //console.log('Eligible Items Object', eligibleItemsObj);

      return eligibleItemsObj;
    },

    //Create Object of Current Item
    getCurrentItemInfo: function () {

      var self = this;

      var itemObj = {};
      itemObj.itemId = this.item.internalid;
      itemObj.sku = this.item.itemid;
      itemObj.itemName = this.item.keyMapping_name;
      itemObj.itemURL = this.item.keyMapping_url;
      itemObj.price = this.item.keyMapping_price;
      itemObj.priceFormatted = this.item.keyMapping_price_formatted;
      itemObj.thumbnailUrl = this.item.keyMapping_thumbnail.url;
      itemObj.thumbnailAlt = this.item.keyMapping_thumbnail.altimagetext
        ? this.item.keyMapping_thumbnail.altimagetext
        : this.item.keyMapping_name;
      itemObj.maximumQuantity = this.item.keyMapping_maximumQuantity;
      itemObj.minimumQuantity = this.item.keyMapping_minimumQuantity;
      itemObj.quantityIncrement = this.item.custitem_qty_increment
        ? this.item.custitem_qty_increment
        : 1;
      itemObj.quantity = this.item.custitem_qty_increment
        ? this.item.custitem_qty_increment
        : 1;

      itemObj.itemBadge = true;
      itemObj.touchpoint = this.touchpoint;
      itemObj.showRating = this.showRating;

      //DON'T SHOW PRICE
      itemObj.noPrice = this.item.dontshowprice;
      itemObj.noPriceMessage = this.item.nopricemessage;

      //STRIKETHROUGH PROPERTIES
      itemObj.strikeThroughForMatrix = this.strikeThroughForMatrix;
      itemObj.strikeThroughEnabled = false;
      itemObj.comparePrice = '';

      if (this.strikethroughEnabled) {
        var newPrice = this.item.keyMapping_price;
        var oldPrice = this.item[SC.CONFIGURATION.priceLevel.default];
        itemObj.strikeThroughEnabled = newPrice < oldPrice ? true : false;
        itemObj.comparePrice = this.item[SC.CONFIGURATION.priceLevel.default + '_formatted'];
        var savedMoney = parseFloat(oldPrice) - parseFloat(newPrice);
        var porcentageSaved = (parseFloat(savedMoney) * 100 / parseFloat(oldPrice));
        var savedMessage = "$" + parseFloat(savedMoney).toFixed(2) + " (" + parseInt(porcentageSaved) + "%)";
        itemObj.saveMoney = savedMessage;
      }

      //NO PRICE PROPERTIES
      if (itemObj.noPrice) {
        if (itemObj.noPriceMessage) {
          itemObj.priceFormatted = itemObj.noPriceMessage;
        } else {
          itemObj.priceFormatted = "See Price in Cart";
        }
      }

      //Get Matrix Child
      itemObj.isMatrix = false;
      itemObj.hasOptions = _.isEmpty(this.item.itemoptions_detail) ? false : true;

      if (itemObj.hasOptions) {
        itemObj.isMatrix = this.item.itemoptions_detail.matrixtype && this.item.itemoptions_detail.matrixtype == "parent" ? true : false;
      }

      if (itemObj.isMatrix) {
        var itemOptionsDetail = this.item.itemoptions_detail.fields;
        _.each(itemOptionsDetail, function (option) {
          //Exclude Non-Matrix Fields or Fields Without Values
          if (option.ismatrixdimension && !_.isEmpty(option.values)) {
            itemObj.optionLabel = option.label;
            itemObj.optionName = option.sourcefrom;
          }
        });

        //Get Matrix Child Item Information
        var itemInfo = this.item;
        var matrixChildArr = this.getMatrixChildItemsInfo(itemObj, itemInfo);
        itemObj.matrixChildItems = matrixChildArr;

        //Set Default Matrix Option
        var defaultMatrixArr = [];
        var defaultMatrixObj = {};
        defaultMatrixObj = matrixChildArr[0];
        defaultMatrixArr.push(defaultMatrixObj);
        itemObj.matrixChildItemsDefault = defaultMatrixArr;
      }

      //Product Review
      var value = this.item.custitem_ns_pr_rating
        ? this.item.custitem_ns_pr_rating
        : 0;
      var fill_value = Math.round(value * 2) / 2,
        max_value = SC.CONFIGURATION.productReviews.maxRate;

      itemObj.maxValue = max_value;
      itemObj.value = value;
      itemObj.fillValue = fill_value;
      itemObj.filledBy = (fill_value * 100) / max_value;
      itemObj.buttons = _.range(max_value);
      itemObj.ratingCount = this.item.custitem_ns_pr_count
        ? this.item.custitem_ns_pr_count
        : 0;

      //console.log('Current Item Object', itemObj);

      return itemObj;
    },

    //Create Object of Eligible Correlated Items
    getCorrelatedItemsInfo: function () {
      var self = this;

      var eligibleItems =
      this.item.custitem_tt_override_fbt &&
        this.item.custitem_tt_override_item_list_id != ""
          ? _.filter(this.overrideFBTItems, function (item, index) {
            return index <= 2;
          })
          : this.getEligibleInfo();

      var correlatedItemsObj = [];

      _.each(eligibleItems, function (item) {
        var itemObj = {};

        itemObj.itemId = item.internalid;
        itemObj.sku = item.itemid;
        itemObj.itemName = item.storedisplayname2;
        itemObj.itemURL = "/" + item.urlcomponent;
        itemObj.price = item.onlinecustomerprice_detail.onlinecustomerprice;
        itemObj.priceFormatted =
          item.onlinecustomerprice_detail.onlinecustomerprice_formatted;

        var hasImage = _.isEmpty(item.itemimages_detail) ? false : true;

        itemObj.thumbnailUrl = "";
        itemObj.thumbnailAlt = item.storedisplayname2;

        if (hasImage) {
          var getKey = _.keys(item.itemimages_detail)[0];
          itemObj.thumbnailUrl = item.itemimages_detail[getKey].urls[0].url;
          itemObj.thumbnailAlt = item.itemimages_detail[getKey].urls[0]
            .altimagetext
            ? item.itemimages_detail[getKey].urls[0].altimagetext
            : item.storedisplayname2;
        }

        itemObj.maximumQuantity = item.maximumquantity;
        itemObj.minimumQuantity = item.minimumquantity;
        itemObj.quantityIncrement = item.custitem_qty_increment
          ? item.custitem_qty_increment
          : 1;
        itemObj.quantity = item.custitem_qty_increment
          ? item.custitem_qty_increment
          : 1;

        itemObj.itemBadge = false;
        itemObj.touchpoint = self.touchpoint;
        itemObj.showRating = self.showRating;


        //DON'T SHOW PRICE
        itemObj.noPrice = item.dontshowprice;
        itemObj.noPriceMessage = item.nopricemessage;

        //STRIKETHROUGH PROPERTIES
        itemObj.strikeThroughForMatrix = self.strikeThroughForMatrix;
        itemObj.strikeThroughEnabled = false;
        itemObj.comparePrice = '';

        if (self.strikethroughEnabled) {
          var newPrice = item.onlinecustomerprice_detail.onlinecustomerprice;
          var oldPrice = item[SC.CONFIGURATION.priceLevel.default];
          itemObj.strikeThroughEnabled = newPrice < oldPrice ? true : false;
          itemObj.comparePrice = item[SC.CONFIGURATION.priceLevel.default + '_formatted'];
          var savedMoney = parseFloat(oldPrice) - parseFloat(newPrice);
          var porcentageSaved = (parseFloat(savedMoney) * 100 / parseFloat(oldPrice));
          var savedMessage = "$" + parseFloat(savedMoney).toFixed(2) + " (" + parseInt(porcentageSaved) + "%)";
          itemObj.saveMoney = savedMessage;
        }

        //NO PRICE PROPERTIES
        if (itemObj.noPrice) {
          if (itemObj.noPriceMessage) {
            itemObj.priceFormatted = itemObj.noPriceMessage;
          } else {
            itemObj.priceFormatted = "See Price in Cart";
          }
        }

        //Get Matrix Child
        itemObj.isMatrix = false;
        itemObj.hasOptions = _.isEmpty(item.itemoptions_detail) ? false : true;
        
        if (itemObj.hasOptions) {
          itemObj.isMatrix = item.itemoptions_detail.matrixtype && item.itemoptions_detail.matrixtype == "parent" ? true : false;
        }

        if (itemObj.isMatrix) {
          var itemOptionsDetail = item.itemoptions_detail.fields;

          _.each(itemOptionsDetail, function (option) {
            //Exclude Non-Matrix Fields or Fields Without Values
            if (option.ismatrixdimension && !_.isEmpty(option.values)) {
              itemObj.optionLabel = option.label;
              itemObj.optionName = option.sourcefrom;
            }
          });

          //Get Matrix Child Item Information
          var itemInfo = item;
          var matrixChildArr = self.getMatrixChildItemsInfo(itemObj, itemInfo);
          itemObj.matrixChildItems = matrixChildArr;

          //Set Default Matrix Option
          var defaultMatrixArr = [];
          var defaultMatrixObj = {};
          defaultMatrixObj = matrixChildArr[0];
          defaultMatrixArr.push(defaultMatrixObj);
          itemObj.matrixChildItemsDefault = defaultMatrixArr;
        }

        //Product Review
        var value = item.custitem_ns_pr_rating ? item.custitem_ns_pr_rating : 0;
        var fill_value = Math.round(value * 2) / 2,
          max_value = SC.CONFIGURATION.productReviews.maxRate;

        itemObj.maxValue = max_value;
        itemObj.value = value;
        itemObj.fillValue = fill_value;
        itemObj.filledBy = (fill_value * 100) / max_value;
        itemObj.buttons = _.range(max_value);
        itemObj.ratingCount = item.custitem_ns_pr_count
          ? item.custitem_ns_pr_count
          : 0;

        correlatedItemsObj.push(itemObj);
      });

      //console.log('Correlated Items Object', correlatedItemsObj);

      return correlatedItemsObj;
    },

    //Create Object of Matrix Child Items
    getMatrixChildItemsInfo: function (itemObj, itemInfo) {

      var self = this;

      var matrixChildArr = [];

      var matrixChildItems = itemInfo.matrixchilditems_detail;

      _.each(matrixChildItems, function (childItem) {
        var matrixChildObj = {};

        matrixChildObj.parentId = itemInfo.internalid;
        matrixChildObj.itemId = childItem.internalid;
        matrixChildObj.sku = childItem.itemid;
        matrixChildObj.optionName = childItem[itemObj.optionName];
        matrixChildObj.price =
          childItem.onlinecustomerprice_detail.onlinecustomerprice;
        matrixChildObj.priceFormatted =
          childItem.onlinecustomerprice_detail.onlinecustomerprice_formatted;
        matrixChildObj.maximumQuantity = childItem.maximumQuantity
          ? childItem.maximumQuantity
          : itemInfo.maximumQuantity;
        matrixChildObj.minimumQuantity = childItem.minimumquantity
          ? childItem.minimumquantity
          : itemInfo.minimumquantity;
        var parentQtyIncrement = itemInfo.custitem_qty_increment
          ? itemInfo.custitem_qty_increment
          : 1;
        matrixChildObj.quantityIncrement = childItem.custitem_qty_increment
          ? childItem.custitem_qty_increment
          : parentQtyIncrement;
        matrixChildObj.quantity = childItem.custitem_qty_increment
          ? childItem.custitem_qty_increment
          : itemInfo.custitem_qty_increment;

        //DON'T SHOW PRICE
        matrixChildObj.noPrice = itemInfo.dontshowprice;
        matrixChildObj.noPriceMessage = itemInfo.nopricemessage;

        //STRIKETHROUGH PROPERTIES
        matrixChildObj.strikeThroughForMatrix = self.strikeThroughForMatrix;
        matrixChildObj.strikeThroughEnabled = false;
        matrixChildObj.comparePrice = '';

        if (self.strikethroughEnabled) {
          var newPrice = childItem.onlinecustomerprice_detail.onlinecustomerprice;
          var oldPrice = childItem[SC.CONFIGURATION.priceLevel.default];
          matrixChildObj.strikeThroughEnabled = newPrice < oldPrice ? true : false;
          matrixChildObj.comparePrice = childItem[SC.CONFIGURATION.priceLevel.default + '_formatted'];
          var savedMoney = parseFloat(oldPrice) - parseFloat(newPrice);
          var porcentageSaved = (parseFloat(savedMoney) * 100 / parseFloat(oldPrice));
          var savedMessage = "$" + parseFloat(savedMoney).toFixed(2) + " (" + parseInt(porcentageSaved) + "%)";
          matrixChildObj.saveMoney = savedMessage;
        }

        //NO PRICE PROPERTIES
        if (matrixChildObj.noPrice) {
          if (matrixChildObj.noPriceMessage) {
            matrixChildObj.priceFormatted = matrixChildObj.noPriceMessage;
          } else {
            matrixChildObj.priceFormatted = "See Price in Cart";
          }
        }

        matrixChildArr.push(matrixChildObj);
      });

      // //Sort Option Alphabetically
      // matrixChildArr.sort(function (a, b) {
      //   return a.optionName.localeCompare(b.optionName);
      // });

      //console.log('Matrix Child Items for ' + itemObj.sku, matrixChildArr);

      return matrixChildArr;
    },

    //  **** End Get Item Information Function ****

    events: {
      'click [data-action="changeQuantity"]': "getQuantity",
      'mouseover [data-action="changeQuantity"]': "getQuantity",
      'change [data-action="changeQuantity"]': "validateQuantity",
      'click [data-action="plus-quantity"]': "addQuantity",
      'click [data-action="minus-quantity"]': "subQuantity",
      'click [data-action="select-item"]': "selectItems",
      'click [data-action="select-option"]': "getOption",
      'change [data-action="select-option"]': "changeOption",
      'click [data-action="add-items"]': "addItems",

      //Comment out if not using Dummy Select Boxes on Template
      'click [data-action="select-dummy"]': "selectDummy",
    },

    // **** Start Quantity Events *****

    addQuantity: function (e) {
      e.preventDefault();

      var $element = this.$(e.target),
        quantityInput = $element.parent().find("input"),
        oldValue = quantityInput.val(),
        maxQuantity = jQuery(quantityInput).attr("data-maximum"),
        incrementQuantity = jQuery(quantityInput).attr("data-increment"),
        newValue = parseFloat(oldValue) + parseInt(incrementQuantity);

      newValue = maxQuantity ? Math.min(maxQuantity, newValue) : newValue;

      quantityInput.val(newValue);
      quantityInput.change();

      //Change Subtotal
      this.selectItems();
    },

    subQuantity: function (e) {
      e.preventDefault();

      var $element = this.$(e.target),
        quantityInput = $element.parent().find("input"),
        oldValue = quantityInput.val(),
        getMinQuantity = jQuery(quantityInput).attr("data-minimum"),
        decrementQuantity = jQuery(quantityInput).attr("data-increment"),
        minQuantity = getMinQuantity ? getMinQuantity : decrementQuantity,
        newValue = parseFloat(oldValue) - parseInt(decrementQuantity);

      newValue = Math.max(minQuantity, newValue);

      quantityInput.val(newValue);
      quantityInput.change();

      //Change Subtotal
      this.selectItems();
    },

    getQuantity: function getQuantity(e) {
      e.preventDefault();

      var $element = this.$(e.target),
        quantityInput = $element.parent().find("input");

      this.oldQuantity = quantityInput.val();
    },

    //Validation based on Minimum Quantity and Web Store Quantity Increment
    validateQuantity: function validateQuantity(e) {
      e.preventDefault();

      var $element = this.$(e.target),
        quantityInput = $element.parent().find("input"),
        quantityValue = quantityInput.val(),
        itemId = jQuery(quantityInput).attr("data-item-id"),
        quantityIncrement = jQuery(quantityInput).attr("data-increment"),
        isInvalid = quantityValue % quantityIncrement != 0 ? true : false,
        isNull = quantityValue == 0 || quantityValue == null;

      if (isInvalid) {
        this.pdp.showMessage({
          message:
            "Invalid Quantity. Please order in multiples of " +
            quantityIncrement,
          type: "error",
          selector: "QuantityError-" + itemId,
          timeout: 2000,
        });

        var newValue = parseFloat(this.oldQuantity);

        quantityInput.val(newValue);
        quantityInput.change();

        return new jQuery.Deferred().reject();
      }

      if (isNull) {
        this.pdp.showMessage({
          message:
            "Invalid Quantity. Minimum quantity should be " + quantityIncrement,
          type: "error",
          selector: "QuantityError-" + itemId,
          timeout: 2000,
        });

        var newValue = parseFloat(quantityIncrement);

        quantityInput.val(newValue);
        quantityInput.change();

        return new jQuery.Deferred().reject();
      }

      //Change Subtotal
      this.selectItems();
    },

    //  **** End Quantity Events ****

    // **** Start Click Events *****

    //Select Item Function
    selectItems: function selectItems() {
      var chkbox = jQuery(
        "input[name=frequentlyboughttogether-add-to-cart-chkbx]"
      ),
        itemRate = jQuery("span[name=frequentlyboughttogether-price-lead]");

      //Creates Array of Item Price
      var priceArr = [];

      jQuery(chkbox).each(function () {
        var currentChkbox = jQuery(this);

        if (currentChkbox.prop("checked")) {
          var itemId = jQuery(currentChkbox).attr("data-item-id");

          jQuery(itemRate).each(function () {
            var currentItem = jQuery(this);
            var rateId = jQuery(currentItem).attr("data-item-id");

            if (itemId == rateId) {
              var priceObj = {};

              priceObj.sku = jQuery(currentItem).attr("data-sku");
              priceObj.price = jQuery(currentItem).attr("data-rate");
              priceObj.quantity = jQuery(
                "input#frequentlyboughttogether-item-quantity[data-item-id='" +
                itemId +
                "']"
              ).val();

              priceArr.push(priceObj);
            }
          });
        }
      });

      //console.log('Price Array', priceArr);

      //Disables Add To Cart Button if No Items Selected
      var checked = jQuery(
        "input[name=frequentlyboughttogether-add-to-cart-chkbx]:checked"
      ),
        count = jQuery(checked).length;

      if (count < 1) {
        this.$("#frequentlyboughttogether-add-to-cart-button").attr(
          "disabled",
          "disabled"
        );
      } else {
        this.$("#frequentlyboughttogether-add-to-cart-button").removeAttr(
          "disabled"
        );
      }

      //Changes Subtotal
      var getPriceArray = priceArr;
      var getSubtotal = this.getSubtotal(getPriceArray);
      jQuery(".frequentlyboughttogether-item-row-subtotal")
        .contents()
        .last()[0].textContent = getSubtotal;

      //Changes Total Count of Items Selected
      var totalItems = jQuery(
        "input[name=frequentlyboughttogether-add-to-cart-chkbx]:checked"
      ).length;

      if (jQuery(".frequentlyboughttogether-item-row-total-items").length) {
        this.$(".frequentlyboughttogether-item-row-total-items")
          .contents()
          .last()[0].textContent = totalItems;
      }

      if (jQuery(".frequentlyboughttogether-item-header-total-items").length) {
        this.$(".frequentlyboughttogether-item-header-total-items")
          .contents()
          .last()[0].textContent = totalItems;
      }

      var noun = totalItems > 1 ? " Items" : " Item";
      this.$(".frequentlyboughttogether-item-row-total-text")
        .contents()
        .last()[0].textContent = noun;
    },

    getOption: function getOption(e) {
      var el = this.$(e.currentTarget);
      this.oldOption = jQuery(el).val();
    },

    //Change Item Option Function
    changeOption: function changeOption(e) {
      var self = this;

      var oldItemId = self.oldOption;

      //Get Item and Parent Item
      var el = this.$(e.currentTarget),
        itemId = jQuery(el).val(),
        parentId = jQuery(el).find(":selected").attr("data-parent-id");

      var getParent = this.frequentlyBoughtItemsArr.filter(function (i) {
        return i.itemId == parentId;
      });

      var getOptionInfo;

      _.each(getParent, function (item) {
        getOptionInfo = item.matrixChildItems.filter(function (i) {
          return i.itemId == itemId;
        });
      });

      //console.log('Item Option Information', getOptionInfo);

      var newVal = getOptionInfo[0];
      //Change Price
      this.$("span.matrix-price[data-item-id='" + oldItemId + "']").attr(
        "data-item-id",
        itemId
      );
      this.$("span.matrix-price[data-item-id='" + itemId + "']").attr(
        "data-rate",
        newVal.price
      );
      this.$("span.matrix-price[data-item-id='" + itemId + "']")
        .contents()
        .last()[0].textContent = newVal.priceFormatted + ' ';

      this.$("span.matrix-price[data-item-id='" + itemId + "']").attr(
        "compare-price",
        newVal.comparePrice
      );

      //If Strike Through For Matrix is Enabled
      if (newVal.strikeThroughForMatrix && !newVal.noPrice) {

        if (newVal.strikeThroughEnabled) {
          this.$("small.product-views-price-old[data-item-id='" + oldItemId + "']").attr(
            "data-item-id",
            itemId
          );
          this.$("small.product-views-price-old[data-item-id='" + itemId + "']")
            .contents()
            .last()[0].textContent = newVal.comparePrice + ' ';

          this.$("span.product-views-save-money[data-item-id='" + oldItemId + "']").attr(
            "data-item-id",
            itemId
          );

          var comparePrice = (newVal.comparePrice).substring(1);
          var savedMoney = parseFloat(comparePrice) - parseFloat(newVal.price);
          var porcentageSaved = (parseFloat(savedMoney) * 100 / parseFloat(comparePrice));
          var savedMessage = "Save $" + parseFloat(savedMoney).toFixed(2) + " (" + parseInt(porcentageSaved) + "%)";

          this.$("span.product-views-save-money[data-item-id='" + itemId + "']")
            .contents()
            .last()[0].textContent = savedMessage;

        } else {

          this.$("small.product-views-price-old[data-item-id='" + oldItemId + "']").attr(
            "data-item-id",
            itemId
          );
          this.$("small.product-views-price-old[data-item-id='" + itemId + "']")
            .contents()
            .last()[0].textContent = '';

          this.$("span.product-views-save-money[data-item-id='" + oldItemId + "']").attr(
            "data-item-id",
            itemId
          );

          this.$("span.product-views-save-money[data-item-id='" + itemId + "']")
            .contents()
            .last()[0].textContent = '';

        }

      }

      //Change Quantity
      this.$("input.matrix-qty[data-item-id='" + oldItemId + "']").attr(
        "data-item-id",
        itemId
      );
      this.$("input.matrix-qty[data-item-id='" + itemId + "']").attr(
        "data-sku",
        newVal.sku
      );
      this.$("input.matrix-qty[data-item-id='" + itemId + "']").attr(
        "data-maximum",
        newVal.maximumQuantity
      );
      this.$("input.matrix-qty[data-item-id='" + itemId + "']").attr(
        "data-minimum",
        newVal.minimumQuantity
      );
      this.$("input.matrix-qty[data-item-id='" + itemId + "']").attr(
        "data-increment",
        newVal.quantityIncrement
      );
      this.$("input.matrix-qty[data-item-id='" + itemId + "']").val(
        newVal.quantity
      );

      //Change Quantity Error
      this.$(
        "div.product-details-quantity-error[data-item-id='" + oldItemId + "']"
      ).attr("data-item-id", itemId);
      this.$(
        "div.product-details-quantity-error[data-item-id='" + itemId + "']"
      ).attr("data-view", "QuantityError-" + itemId);

      //Change Quantity Increment
      this.$("button.matrix-qty-btn[data-item-id='" + oldItemId + "']").attr(
        "data-item-id",
        itemId
      );
      this.$("button.matrix-qty-btn[data-item-id='" + itemId + "']").attr(
        "data-value",
        newVal.quantityIncrement
      );

      //Change Minimum Quantity
      this.$(
        "span.matrix-qty-increment[data-item-id='" + oldItemId + "']"
      ).attr("data-item-id", itemId);
      this.$("span.matrix-qty-increment[data-item-id='" + itemId + "']")
        .contents()
        .last()[0].textContent = newVal.quantityIncrement;

      //Change Select Box
      this.$("input.matrix-select[data-item-id='" + oldItemId + "']").attr(
        "data-item-id",
        itemId
      );
      this.$("input.matrix-select[data-item-id='" + itemId + "']").attr(
        "data-sku",
        newVal.sku
      );

      //Change Subtotal
      this.selectItems();
    },

    //Compute Subtotal
    getSubtotal: function getSubtotal(getPriceArray) {
      //console.log('Price Array for Subtotal', getPriceArray);

      var _subtotal = 0;
      getPriceArray.reduce(function (sum, current) {
        _subtotal = sum + current.price * current.quantity;
        return (self.subtotal = _subtotal);
      }, 0);

      var subtotal =
        "$" +
        _subtotal
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return subtotal;
    },

    //Add to Cart Function
    addItems: function addItems() {
      var chkbox = jQuery(
        "input[name=frequentlyboughttogether-add-to-cart-chkbx]"
      ),
        qtyInput = jQuery("input[name=frequentlyboughttogether-item-quantity]");

      //Creates Item Array for addLines Function
      var itemsArr = [];

      jQuery(chkbox).each(function () {
        var currentChkbox = jQuery(this);

        if (currentChkbox.prop("checked")) {
          var itemId = jQuery(currentChkbox).attr("data-item-id");

          jQuery(qtyInput).each(function () {
            var currentQty = jQuery(this),
              qtyId = jQuery(currentQty).attr("data-item-id");

            if (itemId == qtyId) {
              var qty = jQuery(currentQty).val();

              var itemsObj = {};

              itemsObj.item = { internalid: itemId };
              itemsObj.quantity = parseInt(qty);

              itemsArr.push(itemsObj);
            }
          });
        }
      });

      //console.log('Add Items To Cart', itemsArr);

      //addLines Function and Confirmation Message

      var cartComponent = this.cart;
      var getLayout = this.getLayout;
      var viewCart = this.viewCart;
      var totalItems = itemsArr.length;
      var noun = totalItems > 1 ? "items" : "item";
      var linkingVerb = totalItems > 1 ? "are" : "is";

      cartComponent
        .addLines({
          lines: itemsArr,
        })
        .then(function () {
          var view = new GlobalViewsConfirmationView({
            title: Utils.translate("Added To Cart"),
            body: Utils.translate(
              totalItems +
              " " +
              noun +
              " " +
              linkingVerb +
              " successfully added to your cart."
            ),
            callBack: viewCart,
            confirmLabel: Utils.translate("View Cart & Checkout"),
            cancelLabel: Utils.translate("Continue Shopping"),
            class: "frequently-bought-global-views-modal-content-body",
            autohide: true,
          });
          getLayout.showInModal(view);
        });
    },

    //Dummy Select Box Function - Comment out if not using Dummy Select Boxes on Template
    selectDummy: function selectDummy(e) {
      var $element = this.$(e.target),
        dummyChkbox = $element.parent().find("input"),
        inputVal = dummyChkbox.val(),
        isChecked = dummyChkbox.prop("checked"),
        itemId = jQuery(dummyChkbox).attr("data-item-id"),
        selectChkbox = jQuery(
          "input#frequentlyboughttogether-add-to-cart-chkbx[data-item-id='" +
          itemId +
          "']"
        );

      if (isChecked) {
        //Check Select Boxes with same Data Item ID
        jQuery(selectChkbox).each(function () {
          var findChkbox = jQuery(this);
          jQuery(findChkbox).prop("checked", true);
        });
      } else if (!isChecked) {
        //Uncheck Select Boxes with same Data Item ID
        jQuery(selectChkbox).each(function () {
          var findChkbox = jQuery(this);
          jQuery(findChkbox).prop("checked", false);
        });
      }

      //Change Subtotal
      this.selectItems();
    },

    //Redirects Shoppers to Cart after addLines Function
    viewCart: function viewCart() {
      Backbone.history.navigate("#cart", { trigger: true });
    },

    // **** End Click Events *****

    //@method getContext @return Tavanoteam.FrequentlyBoughtTogether.FrequentlyBoughtTogether.View.Context
    getContext: function getContext() {
      //@class Tavanoteam.FrequentlyBoughtTogether.FrequentlyBoughtTogether.View.Context
      var self = this;

      //Get Eligible Items
      this.eligibleItems = this.eligibleItems || [];

      //If Item has Eligible Correlated Items
      this.hasEligibleItems = this.eligibleItems.length > 0 ? true : false;

      if (this.hasEligibleItems) {
        //Get Item Objects
        var currentItem = this.getCurrentItemInfo();
        var correlatedItems = this.getCorrelatedItemsInfo();

        //Create Frequently Bought Items Array
        this.frequentlyBoughtItemsArr = [];

        //Push Current Item Information to Frequently Bought Items Array
        this.frequentlyBoughtItemsArr.push(currentItem);

        //Push Correlated Items Information to Frequently Bought Items Array
        _.each(correlatedItems, function (item) {
          self.frequentlyBoughtItemsArr.push(item);
        });

        //console.log('All Items Array', this.frequentlyBoughtItemsArr);

        //Default Total Count of Items Selected - Changes on selectItems()
        this.totalItems = this.frequentlyBoughtItemsArr.length;

        //Default Subtotal - Changes on selectItems()
        var getPriceArray = [];
        _.each(this.frequentlyBoughtItemsArr, function (item) {
          var priceObj = {};

          if (item.isMatrix && item.matrixChildItemsDefault[0]) {
            priceObj.sku = item.matrixChildItemsDefault[0].sku;
            priceObj.price = item.matrixChildItemsDefault[0].price;
            priceObj.quantity = item.matrixChildItemsDefault[0].quantityIncrement;
          } else {
            priceObj.sku = item.sku;
            priceObj.price = item.price;
            priceObj.quantity = item.quantityIncrement;
          }
          getPriceArray.push(priceObj);
        });

        this.subtotal = this.getSubtotal(getPriceArray);
      }

      return {
        hasEligibleItems: this.hasEligibleItems,
        frequentlyBoughtItems: this.frequentlyBoughtItemsArr
          ? this.frequentlyBoughtItemsArr
          : [],
        subtotal: this.subtotal ? this.subtotal : "$0.00",
        totalItems: this.totalItems ? this.totalItems : "0",
        totalText: this.totalItems > 1 ? "Items" : "Item",
      };
    },
  });
});
